<template>
    <div :id="id" class="panel panel-default" :style="{
        'margin-bottom': marginBottom,
    }">
        <div class="panel-heading" v-if="title">
            <h4>{{ title }}</h4>
        </div>
        <div class="panel-body">
            <slot></slot>
        </div>
        <div class="panel-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
        marginBottom: {
            type: String,
            required: false,
            default: null,
        },
        title: {
            type: String,
            required: false,
            default: null,
        }
    }
}
</script>